module.exports = __webpack_public_path__ + "nc_static/media/filter-sm.e861bb4d.svg";